module.exports = __webpack_public_path__ + "img/step1.9ac05eac.png";